import React from "react";
import { Box, IconButton } from "@mui/material";
import {
  MenuRounded,
  ChevronLeftRounded,
} from "@mui/icons-material";
import useTranslation from "../../../shared/hooks/useTranslation";
import MidasLogo from "./MidasLogo";
import { dt } from "../../../shared/themes/redesignTokens";
import { SidebarState } from "../midasPageModels";

// ═══════════════════════════════════════════════════════════════
//  MIDAS Design Tokens (local subset)
// ═══════════════════════════════════════════════════════════════

const midas = {
  gold: "#D4A017",
};

// ═══════════════════════════════════════════════════════════════
//  MidasSidebarHeader
// ═══════════════════════════════════════════════════════════════

interface MidasSidebarHeaderProps {
  sidebarState: SidebarState;
  onToggle: () => void;
}

const MidasSidebarHeader: React.FC<MidasSidebarHeaderProps> = ({
  sidebarState,
  onToggle,
}) => {
  const { translate } = useTranslation("chatBot");
  const isExpanded = sidebarState === "expanded";

  return (
    <Box
      sx={{
        height: "48px",
        display: "flex",
        alignItems: "center",
        gap: "10px",
        padding: isExpanded ? "0 12px 0 16px" : "0 4px",
        justifyContent: isExpanded ? "flex-start" : "center",
        borderBottom: `1px solid ${dt.cardBorder}`,
        flexShrink: 0,
      }}
    >
      {isExpanded && (
        <>
          <MidasLogo size="lg" />
          <Box
            sx={{
              fontFamily: dt.font,
              fontSize: "15px",
              fontWeight: 700,
              color: dt.textPrimary,
              letterSpacing: "0.5px",
              flex: 1,
            }}
          >
            {translate("botName")}
          </Box>
        </>
      )}

      {isExpanded ? (
        <IconButton
          onClick={onToggle}
          size="small"
          sx={{
            color: dt.textSecondary,
            padding: "6px",
            borderRadius: "6px",
            "&:hover": {
              color: dt.textPrimary,
              backgroundColor: "rgba(0,0,0,0.04)",
            },
          }}
          aria-label={translate("midas.aria.closeSidebar") || "Close sidebar"}
        >
          <ChevronLeftRounded sx={{ fontSize: "20px" }} />
        </IconButton>
      ) : (
        <Box
          onClick={onToggle}
          sx={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "6px",
            padding: "4px",
            "&:hover": { backgroundColor: "rgba(0,0,0,0.04)" },
          }}
          role="button"
          aria-label={translate("botName") || "MIDAS"}
        >
          <MidasLogo size="md" />
        </Box>
      )}
    </Box>
  );
};

export default MidasSidebarHeader;
